import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router';
import { useMaskito } from '@maskito/react';
import { masks } from '../../utils/mask';
import { FiChevronLeft } from 'react-icons/fi';

import '../../styles/global.scss';
import './styles.scss';

import { useAuth } from '../../hooks/useAuth';
import { Button } from '../../components/Button';

type StatusAlertType = {
  status: string;
  message: string;
};

function SignIn() {
  const { partner } = useParams();
  const navigate = useNavigate(); // Hook para navegação
  const [statusMessageAlert, setStatusMessageAlert] = useState<StatusAlertType | null>(null);
  const [cpf, setCpf] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const { handleLogin, loading, authenticated } = useAuth();
  const cpfRef = useMaskito({ options: masks.cpf });

  useEffect(() => {
    if (process.env.REACT_APP_FAKER === 'true') {
      setCpf(process.env.REACT_APP_FAKER_CPF_FGTS ?? '');
    }
  }, []);

  useEffect(() => {
    if (authenticated) {
      navigate('/admin/home'); // Redireciona se o usuário já estiver autenticado
    }
  }, [authenticated, navigate]);

  async function handleSignIn() {
    const unmaskedCpf = cpf.replace(/[^\d]+/g, '');

    setStatusMessageAlert(null);

    if (unmaskedCpf === '' || password === '') {
      setStatusMessageAlert({
        status: 'error',
        message: 'Preencha o CPF e senha para continuar.',
      });
      return;
    }

    const response = await handleLogin(unmaskedCpf, password);

    if (response) {
      setStatusMessageAlert({
        status: 'error',
        message: 'Dados incorretos, favor verificar e tentar novamente.',
      });
    } else {
      navigate('/admin/home'); // Redireciona ao sucesso
    }
  }

  return (
    <div id="page-auth">
      <aside>
        <p className='back-home-link'>
          <FiChevronLeft className='left-chevron' />
          <Link to="/">Voltar</Link>
        </p>
        <strong>Entrar</strong>
        <p>Aqui você consegue entrar na sua área logada.</p>
      </aside>
      <main>
        <div className="main-content">
          <div className="logoTnb">
            <img src="./images/logo_header.svg" alt="Ta no bolso" />
          </div>
          <form onSubmit={(e) => e.preventDefault()}>
            <h2>Login</h2>
            <div className="form-row">
              <div className="form-group col-md-12">
                <label>CPF</label>
                <input
                  ref={cpfRef}
                  name="cpf"
                  className="form-control"
                  onInput={(e: any) => setCpf(e.target.value)}
                  onKeyDown={(e) => (e.key === 'Enter' ? handleSignIn() : null)}
                  autoComplete="off"
                  value={cpf}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-12">
                <label>Senha</label>
                <input
                  name="password"
                  type="password"
                  className="form-control"
                  onChange={(e: any) => setPassword(e.target.value)}
                  onKeyDown={(e) => (e.key === 'Enter' ? handleSignIn() : null)}
                  value={password}
                />
              </div>
            </div>
            {statusMessageAlert && (
              <div
                className={`alert alert-${statusMessageAlert.status === 'error' ? 'danger' : 'primary'} alert-text-center`}
                role="alert"
              >
                {statusMessageAlert.message}
              </div>
            )}
            <Button type="button" onClick={handleSignIn}>
              {!loading ? 'Entrar' : 'Entrando...'}
            </Button>
            <p>
              <Link to="/recover-password">Esqueceu a senha?</Link>
            </p>
            <p>
              <Link to="/resend-confirmation-email">
                Não recebeu o e-mail de confirmação?
              </Link>
            </p>
            <p>
              <Link to={partner ? `/signup/${partner}` : '/signup'}>
                Não tem conta? Registre-se.
              </Link>
            </p>
          </form>
        </div>
      </main>
    </div>
  );
}

export default SignIn;
